var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected_histories"},_vm._l((_vm.selected_history),function(history,history_key){return _c('DetailItem',{key:history_key,attrs:{"history":history},on:{"hide_info":_vm.hide_info}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }